import Network from '@/common/lib/Network';
import Store from '@/config/store';

export default {

  getCurrentCart() {
    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI
    };

    return Network.execute('GET', 'CWEBS0070B', data);
  },
  setCustomerCartAddr(object) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnbon: Store.getters['panier/get_pnbon'],
    };

    let post_data = {
      ds_i: {
        OUT: object  
      }
    };

    return Network.execute('POST', 'CWEBS0068B', data, post_data, {
      'Content-Type': 'application/json'
    });
  },
  addToCart(query_data) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pnbon_in: Store.getters['panier/get_pnbon'] ? Store.getters['panier/get_pnbon'] : null,
      ...query_data
    };

    return Network.execute('POST', 'CWEBS0078A', data, {}, {
      'Content-Type': 'application/json'
    }); 
  },
  sendContactForm(object) {

    let post_data = {
      ds_i: {
        OUT: [object]  
      }
    };

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI
    }

    return Network.execute('POST', 'CWEBS0069A', data, post_data, {
      'content-type': 'application/json' 
    });

  },
  getCurrentAddr() {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pnumbon: Store.getters['panier/get_pnbon']
    }

    return Network.execute('GET', 'CWEBS0080A', data);

  },
  usualPayment() {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pnbon: Store.getters['panier/get_pnbon'],
      top_paye: 0
    }

    return Network.execute('GET', 'CWEBS0082A', data);
  },
  getDisplayCurrentAddr() {
      return Network.execute('GET', 'CWEBS0086A', {
        pcsoc: Store.getters['application/get_application_company'].PCSOC,
        piduser: Store.getters['application/get_application_user'].id,
        pnocl: Store.getters['application/get_application_customer'].TNCLI,
        pnumbon: Store.getters['panier/get_pnbon']
      });
    }
}